// import RuleOverview from '@/views/pages/dataQuality/ruleOverview/index.vue';
// import DataQuality from '@/views/pages/dataQuality/dataQuality/index.vue';
// import RuleTemplate from '@/views/pages/dataQuality/ruleTemplate/index.vue';
// import JobOverview from '@/views/pages/dataQuality/jobOverview/index.vue';
// import DataQualityIssue from '@/views/pages/dataQuality/dataQualityIssue/index.vue';
// import checkpointOverview from '@/views/pages/dataQuality/checkpointOverview/index.vue';
// import IssuesOverview from '@/views/pages/dataQuality/issuesOverview/index.vue';
// import JobDetail from '@/views/pages/dataQuality/jobDetail/index.vue';
// import DataQualityIssueDetail from '@/views/pages/dataQuality/dataQualityIssueDetail/index.vue';
// import DqReport from '@/views/pages/dataQuality/dqReport/index.vue';

const RuleOverview = () => import('@/views/pages/dataQuality/ruleOverview/index.vue');
const DataQuality = () => import('@/views/pages/dataQuality/dataQuality/index.vue');
const RuleTemplate = () => import('@/views/pages/dataQuality/ruleTemplate/index.vue');
const JobOverview = () => import('@/views/pages/dataQuality/jobOverview/index.vue');
const DataQualityIssue = () => import('@/views/pages/dataQuality/dataQualityIssue/index.vue');
const checkpointOverview = () => import('@/views/pages/dataQuality/checkpointOverview/index.vue');
const IssuesOverview = () => import('@/views/pages/dataQuality/issuesOverview/index.vue');
const JobDetail = () => import('@/views/pages/dataQuality/jobDetail/index.vue');
const DataQualityIssueDetail = () => import('@/views/pages/dataQuality/dataQualityIssueDetail/index.vue');
const DqReport = () => import('@/views/pages/dataQuality/dqReport/index.vue');
const RuleDetail = () => import('@/views/pages/dataQuality/ruleDetail/index.vue');
const RuleTemplateDetail = () => import('@/views/pages/dataQuality/ruleTemplate/ruleTemplateDetail.vue');

const DataQualityRouteList = [
  {
    path: 'dataQuality',
    component: DataQuality,
    name: '/dataQuality',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Data Quality Overview',
      mid: '3c7a-91f2',
    },
  },
  {
    path: 'ruleOverview',
    component: RuleOverview,
    name: '/ruleOverview',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Rules',
      mid: 'e8d1-44b9',
    },
  },
  {
    path: 'ruleTemplate',
    component: RuleTemplate,
    name: '/ruleTemplate',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Rule Template',
      mid: '7f0a-2c8e',
    },
  },
  {
    path: 'dqReport',
    component: DqReport,
    name: '/dqReport',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Report',
      mid: '9b63-d7e5',
    },
  },
  {
    path: 'jobOverview',
    component: JobOverview,
    name: '/jobOverview',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Jobs',
      mid: '2a9f-0e8c',
    },
  },
  {
    path: 'dataQualityIssue',
    component: DataQualityIssue,
    name: '/dataQualityIssue',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Issues',
      mid: '6d54-f3b1',
    },
  },
  {
    path: 'checkpointOverview',
    component: checkpointOverview,
    name: '/checkpointOverview',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Checkpoints Overview',
      mid: 'c1e8-59a7',
    },
  },
  {
    path: 'issuesOverview',
    component: IssuesOverview,
    name: '/issuesOverview',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Issues Overview',
      mid: '0bf2-7d46',
    },
  },
  {
    path: 'jobDetail',
    component: JobDetail,
    name: '/jobDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Data Quality JobDetail',
      mid: 'e5a9-3c81',
    },
  },
  {
    path: 'dataQualityIssueDetail',
    component: DataQualityIssueDetail,
    name: '/dataQualityIssueDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'DQ Issue Detail',
      mid: '8f7d-2b60',
    },
  },
  {
    path: 'ruleDetail',
    component: RuleDetail,
    name: '/ruleDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Rule Detail',
      mid: '49e1-a5c3',
    },
  },
  {
    path: 'ruleTemplateDetail',
    component: RuleTemplateDetail,
    name: '/ruleTemplateDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Rule Detail',
      mid: 'd6b0-7f2e',
    },
  },
];

export default DataQualityRouteList;
